<div [ngSwitch]="orderConfig?.channel">
  <!--Recykal app driver details and UI-->

  <ng-template [ngSwitchCase]="'RECYKAL'">
    <ion-grid no-padding>
      <ion-row no-padding>
        <ion-col
          size="12"
          no-padding-left
          no-padding-right
          *ngIf="orderLogisticsDetails"
        >
          <ion-card
            no-margin
            no-box-shadow
            class="card-expandable driver-details-card"
          >
            <ion-row (click)="driverDetails = !driverDetails">
              <ion-col
                size="12"
                class="card-title"
                no-padding-left=""
                no-padding-right=""
                no-padding-top=""
              >
                <ion-text color="dark" font-bold=""
                  >Driver Information</ion-text
                >
                <ion-icon
                  float-end=""
                  [color]="driverDetails ? 'medium' : 'light'"
                  [name]="
                    driverDetails
                      ? 'arrow-dropup-circle'
                      : 'arrow-dropdown-circle'
                  "
                ></ion-icon>
              </ion-col>
            </ion-row>
            <ion-row *ngIf="driverDetails">
              <ion-col
                size="12"
                no-padding-left=""
                no-padding-right=""
                no-padding-bottom=""
                padding-top=""
              >
                <ion-row>
                  <ion-col size="10" text-left="">
                    <ion-text color="medium" class="info-label" font-bold>
                      Driver Name
                    </ion-text>
                    <br />
                    <ion-text color="dark" class="info" font-bold="">{{
                      orderLogisticsDetails?.driverName
                        ? orderLogisticsDetails?.driverName
                        : "-"
                    }}</ion-text>
                  </ion-col>
                  <ion-col size="2" *ngIf="enableEdit">
                    <ion-button
                      float-end=""
                      [disabled]="
                        containsInStatusLog(orderStatuses.MATERIAL_PICKED)
                      "
                      color="medium"
                      size="small"
                      fill="outline"
                      (click)="openTransportationDetailsModal.emit()"
                    >
                      EDIT
                    </ion-button>
                  </ion-col>

                  <ion-col size="12">
                    <ion-text color="medium" class="info-label" font-bold=""
                      >Driver Mobile Number</ion-text
                    >
                    <br />
                    <ion-text color="dark" class="info" font-bold="">{{
                      orderLogisticsDetails?.driverContact
                        ? orderLogisticsDetails?.driverContact
                        : "-"
                    }}</ion-text>
                  </ion-col>
                  <ion-col size="12">
                    <ion-text color="medium" class="info-label" font-bold=""
                      >ID Proof</ion-text
                    >
                    <br />
                    <ion-text color="dark" class="info" font-bold="">
                      <span
                        *ngIf="
                          orderLogisticsDetails?.idProofNo &&
                          orderLogisticsDetails?.idProof
                        "
                      >
                        {{ orderLogisticsDetails?.idProofNo }} ({{
                          getIdProofDisplayName(orderLogisticsDetails?.idProof)
                        }})
                      </span>
                      <span
                        *ngIf="
                          !(
                            orderLogisticsDetails?.idProofNo &&
                            orderLogisticsDetails?.idProof
                          )
                        "
                        >-</span
                      >
                    </ion-text>
                  </ion-col>
                  <ion-col size="12">
                    <ion-text color="medium" class="info-label" font-bold=""
                      >Driving License</ion-text
                    >
                    <br />
                    <ion-text color="dark" class="info" font-bold="">{{
                      orderLogisticsDetails?.driverLicenceNo
                        ? orderLogisticsDetails?.driverLicenceNo
                        : "-"
                    }}</ion-text>
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-template>

  <!--Stargaze driver details and UI-->

  <ng-template [ngSwitchCase]="'STARGAZE'">
    <ion-card class="driver-details-card card-details">
      <ion-grid>
        <ion-row *ngIf="orderLogisticsDetails; else noDriverDetails">
          <ion-col size="6" text-left="">
            <ion-text
              color="medium"
              class="text-small ion-text-uppercase letter-spacing-1"
              font-bold
            >
              Driver Name
            </ion-text>
            <br />
            <ion-text color="dark" class="info">{{
              orderLogisticsDetails?.driverName
                ? orderLogisticsDetails?.driverName
                : "-"
            }}</ion-text>
          </ion-col>

          <ion-col size="6">
            <ion-text
              color="medium"
              class="text-small ion-text-uppercase letter-spacing-1"
              font-bold=""
              >Driver Mobile Number</ion-text
            >
            <br />
            <ion-text color="dark" class="info">{{
              orderLogisticsDetails?.driverContact
                ? orderLogisticsDetails?.driverContact
                : "-"
            }}</ion-text>
          </ion-col>
          <ion-col size="6">
            <ion-text
              color="medium"
              class="text-small ion-text-uppercase letter-spacing-1"
              font-bold=""
              >ID Proof</ion-text
            >
            <br />
            <ion-text color="dark" class="info">
              <span
                *ngIf="
                  orderLogisticsDetails?.idProofNo &&
                  orderLogisticsDetails?.idProof
                "
              >
                {{ orderLogisticsDetails?.idProofNo }} ({{
                  getIdProofDisplayName(orderLogisticsDetails?.idProof)
                }})
              </span>
              <span
                *ngIf="
                  !(
                    orderLogisticsDetails?.idProofNo &&
                    orderLogisticsDetails?.idProof
                  )
                "
                >-</span
              >
            </ion-text>
          </ion-col>
          <ion-col size="6">
            <ion-text
              color="medium"
              class="text-small ion-text-uppercase letter-spacing-1"
              font-bold=""
              >Driving License</ion-text
            >
            <br />
            <ion-text color="dark" class="info">{{
              orderLogisticsDetails?.driverLicenceNo
                ? orderLogisticsDetails?.driverLicenceNo
                : "-"
            }}</ion-text>
          </ion-col>
        </ion-row>
        <ng-template #noDriverDetails>
          <div
            style="
              height: 15vh;
              display: flex;
              width: 100%;
              flex-direction: column;
            "
            align-items-center
            justify-content-center
          >
            <div text-center *ngIf="!orderLogisticsDetails">
              <ion-title font-bold class="text-large" color="medium"
                >No Driver Details</ion-title
              >
              <ion-text color="medium"
                >There are no Driver Details. Please add your details</ion-text
              >
            </div>
          </div>
        </ng-template>
      </ion-grid>
    </ion-card>
  </ng-template>
</div>
